export default "__VITE_ASSET__8026cc31__"